<script>
import List from "@/components/molecules/list/index";
import ListItem from "@/components/molecules/list/list-item";
import FilterLink from "@/components/molecules/filter-link";
import Button from "@/components/atoms/button";
import {
  productListHeaderAppliedFiltersProps,
  useProductListHeaderAppliedFilters
} from "./mixin";

export default {
  name: "AppliedFilters",
  components: {
    List,
    ListItem,
    FilterLink,
    Button
  },
  props: {
    ...productListHeaderAppliedFiltersProps()
  },
  emits: ["select", "initiateProductFilter"],
  setup() {
    const { getLabel, pagesNiv3et4Codes } =
      useProductListHeaderAppliedFilters();
    return {
      getLabel,
      pagesNiv3et4Codes
    };
  },
  methods: {
    change(checked, value, code) {
      this.$emit("select", checked, code, value);
    }
  }
};
</script>
<template>
  <div
    v-if="appliedFilters.length > 0"
    class="c-applied-filters u-flex"
  >
    <div class="c-applied-filters__label">
      Vos filtres
    </div>
    <List class="c-applied-filters__list">
      <ListItem
        v-for="filter in appliedFilters"
        :key="keyCode ? filter.code : filter.valeur"
      >
        <FilterLink
          actif
          class="u-m-xs"
          :color="filter.color"
          :score="(filter.render_mode === pagesNiv3et4Codes.REVIEW_RENDER_MODE) ? filter.libelle.toLowerCase() :''"
          :nutri-score="(filter.render_mode === pagesNiv3et4Codes.NUTRISCORE_RENDER_MODE) ? filter.libelle.toLowerCase():''"
          :libelle="getLabel(filter.libelle, filter.libelle_facette)"
          @change="change($event, filter.valeur, filter.code)"
        >
          {{ getLabel(filter.libelle, filter.libelle_facette) }}
        </FilterLink>
      </ListItem>
      <ListItem
        v-if="appliedFilters.length > 2"
        class="c-applied-filters-mobile__list-item"
      >
        <Button
          link
          @click="$emit('initiateProductFilter')"
        >
          Tout désélectionner
        </Button>
      </ListItem>
    </List>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/applied-filters.scss";
</style>
